import { html, LitElement, unsafeCSS, css } from 'lit';
import styles from './tabPanel.scss?inline';

export default class SotbitTabPanel extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        active: { type: Boolean, reflect: true },
    };

    constructor() {
        super();
    }

    updated(changedProperties) {
        if (changedProperties.has('active')) {
            if (this.active) {
                requestAnimationFrame(() => {
                    this.style.opacity = 1;
                });
            } else {
                this.style.opacity = 0;
            }
        }
    }

    render() {
        return html` <slot></slot> `;
    }
}
